import { useState, ReactNode } from "react";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";
import TestCredentialsFab from "../common/TestCredentialsFab";
import { useAppSelector } from "../../store/hooks";

interface AdminLayoutProps {
  children: ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const user = useAppSelector((state) => state.auth.user);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100">
      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-40 transition-[width] duration-300 ${
          isSidebarCollapsed ? "w-[60px]" : "w-[248px]"
        }`}
      >
        <Sidebar isCollapsed={isSidebarCollapsed} />
      </div>

      {/* Main area */}
      <div
        className={`min-h-screen flex flex-col transition-[padding] duration-300 ${
          isSidebarCollapsed ? "md:pl-[60px]" : "md:pl-[248px]"
        }`}
      >
        <Header
          onToggleSidebar={() => setIsSidebarCollapsed((prev) => !prev)}
          isCollapsed={isSidebarCollapsed}
          user={user?.name && user?.role ? { name: user.name, role: user.role } : null}
        />

        <main className="flex-1 pt-14">
          <div className="px-6 pt-2 pb-6 max-w-[1600px] mx-auto">
            {children}
          </div>
        </main>
      </div>

      {/* Floating Test Credentials helper (bottom-right) */}
      <TestCredentialsFab />
    </div>
  );
};

export default AdminLayout;
